import { company_name } from "@/i18n/variables";

const password_vault = {
	add_button: "Passwort teilen",
	description: {
		href: "https://support.tuxis.nl/en/knowledgebase/article/never-forget-your-password-again",
		text: `${company_name} oder ein anderer Benutzer in Ihrer Organisation hat die folgenden Passwörter zur Überprüfung mit Ihnen geteilt. <strong>Diese sind 30 Tage lang sichtbar</strong>. Das Ändern eines Passworts hat keine Auswirkungen auf den Dienst. Sie können hier auch Passwörter mit ${company_name} und anderen Benutzern teilen. Möchten Sie vermeiden, dass Sie Ihre Passwörter jemals verlieren? Dann lesen Sie <a>diesen Artikel (Englisch)</a>.`,
	},
	dialog_add: {
		description: "",
		title: "Gemeinsame Anmeldedaten",
	},
	dialog_delete: {
		description: "Sind Sie sicher, dass Sie <strong>{{name}}</strong> löschen möchten?",
		title: "Passwort löschen",
	},
	dialog_update: {
		confirmation: {
			description:
				"Bitte beachten Sie: Die Änderungen, die Sie hier vornehmen, haben keine Auswirkungen auf die Anmeldeinformationen der verknüpften Produkte oder Dienstleistungen.",
			title: "Freigegebenes Passwort aktualisieren",
		},
	},
	generate: "Generieren",
	password_text:
		"Das Passwort ist nicht mit einem Dienst verbunden. Dieses Passwort wird mit Ihnen geteilt. Speichern Sie es in Ihrem Passwort-Manager.",
	status: {
		create_success: "Passwort erfolgreich freigegeben!",
		delete_success: "Passwort erfolgreich gelöscht!",
		successful_copy_otp_secret: "2FA Geheimnis in Zwischenablage kopiert",
		successful_copy_password: "Passwort in Zwischenablage kopiert",
		successful_copy_url: "Hostname/URL in Zwischenablage kopiert",
		successful_copy_username: "Benutzername in Zwischenablage kopiert",
		update_success: "Passwort erfolgreich geändert!",
	},
	table: {
		actions: "Aktionen",
		description: "Beschreibung",
		expires_at: "Sichtbar bis",
		name: "Name",
		not_visible: "Nicht sichtbar",
		otp_secret: "2FA Geheimnis",
		password: "Passwort",
		support_has_access: `${company_name} darf Passwort einsehen`,
		url: "Hostname/URL",
		user_list: "Sichtbar für",
		username: "Benutzername",
	},
	title: "Gemeinsame Passwörter",
};

export default password_vault;
